import React from 'react'
import style from './style.module.css'
import RingIcon from '../../../../../../../assets/svgs/Ring'

import EventItem from './EventItem'

const EventsBlock = () => {
  return (
    <div className={style.companyModal_events}>
      <div className={style.companyModal_events_title}>
        <RingIcon />
        <span>Happening at Chimp</span>
      </div>

      <div className={style.companyModal_events_list}>
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
        <EventItem />
      </div>

      <div className={style.companyModal_events_scrollText}>
        <span>scroll to see more</span>
      </div>
    </div>
  )
}

export default EventsBlock
